import "./NewsPage.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { NewsItem, fetchNews } from "src/network/fetchNews";
import { imageUrl } from "src/network/fullUrl";
import image2 from "../../images/2.png";
import Layout from "src/components/Layout";

const NewsPage = () => {
  const [newsItems, setNewsItems] = useState<NewsItem[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const getNews = async () => {
      try {
        const news = await fetchNews();
        setNewsItems(news);
      } catch (error) {
        console.error("Failed to fetch news:", error);
      }
    };

    getNews();
  }, []);

  return (
    <Layout>
      <section className="news-page">
        <div className="news-container">
          <div className="news-title">
            <h2 className="dotmedico2">dotmedica</h2>
            <h2 className="news-sbed2">news</h2>
          </div>
          <div className="news-items2">
            {newsItems.map((news, index) => (
              <div
                key={`${news?.slug}-${index}`}
                className="news-card"
                onClick={() => navigate(`/news/${news.slug}`)}
              >
                <img
                  src={imageUrl(news?.main_image)}
                  alt={news?.slug}
                  className="news-image"
                  onError={(e) => {
                    e.currentTarget.onerror = null; // Prevents infinite loop in case the fallback image is also broken
                    e.currentTarget.src = image2; // Fallback image URL
                  }}
                />
                <h3>{news?.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default NewsPage;
